import { all, takeLatest, put } from 'redux-saga/effects';
import {
    GET_PERMISSIONS,
    CREATE_PERMISSION,
    UPDATE_PERMISSION,
    INVITE_PERMISSION
} from './constants';
import {
    requestPermissions,
    requestCreatePermission,
    requestUpdatePermission,
    requestInvitePermission
} from './api';
import {
    getPermissionsSuccess,
    createPermissionSuccess,
    updatePermissionSuccess,
    invitePermissionSuccess
} from './actions';

/**
 *
 * @returns {IterableIterator<PutEffect<{permissions: *, type: string}>>}
 */
function* getPermissions() {
    const permissions = yield requestPermissions();
    if (permissions) {
        yield put(getPermissionsSuccess(permissions));
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{permission, type}>>}
 */
function* createPermission(actionObj) {
    try {
        const response = yield requestCreatePermission(actionObj.formData);
        yield put(createPermissionSuccess(response));
    } catch (error) {
        console.error('Invite User Error:', error);
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{permission, type}>>}
 */
function* updatePermission(actionObj) {
    try {
        const response = yield requestUpdatePermission(actionObj.formData);
        yield put(updatePermissionSuccess(response));
    } catch (error) {
        console.error('Invite User Error:', error);
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{permission, type}>>}
 */
function* invitePermission(actionObj) {
    try {
        const response = yield requestInvitePermission(actionObj.formData);
        yield put(invitePermissionSuccess(response));
    } catch (error) {
        console.error('Invite User Error:', error);
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchPermissions() {
    yield takeLatest(GET_PERMISSIONS, getPermissions);
    yield takeLatest(CREATE_PERMISSION, createPermission);
    yield takeLatest(UPDATE_PERMISSION, updatePermission);
    yield takeLatest(INVITE_PERMISSION, invitePermission);
}

function* permissionsSaga() {
    yield all([
        watchPermissions()
    ]);
}

export default permissionsSaga;